async function newLoanQuoteSlackNotification(currentLoan) {
  if (process.env.deployment === "production") {
    const targetUrl = `https://hooks.slack.com/services/${process.env.slackLoanQuoteStarted}`;

    let resp;
    try {
      const res = await fetch(targetUrl, {
        method: "POST",
        //make sure to serialize your JSON body
        body: JSON.stringify({
          // these keys are case sensitive
          text: `New loan request has been submitted.:
          \n Link: cms.offermarket.us/admin/plugins/content-manager/collectionType/application::loans.loans/${currentLoan.id}\n Loan Quote id: ${currentLoan.id}`,
        }),
      });
      resp = await res.json();
    } catch (e) {
      console.log(e);
    }
  }
}

export default newLoanQuoteSlackNotification;
